import React from 'react'
import { LoadableComponent } from 'loadable__component'
import { Theme } from '@material-ui/core/styles'
import ILayout from './layout'
import ITheme, { ILogo } from './theme'
import { IUserFunction } from './auth'
import { IPermission } from './permission'
import IRoute from './route'
import { TSubModules } from './submodules'
import { ICompany } from './company'
import { CreditLimitType } from './covenant'

export interface IInformations {
  empresas: ICompany[]
  empresas_etrabalhador: ICompany[]
  empresa?: ICompany
  id: string
  cnpj: string
  empresa_privada?: boolean
  tipo_limite_credito?: keyof typeof CreditLimitType
  tipo_limite_credito_cartao?: keyof typeof CreditLimitType
  valor_margem_manual?: boolean
  valor_rmc_manual?: boolean
}

export interface IEntity {
  id: string
  name: string
  path: string
  route: { [key: string]: IRoute }
  theme: ITheme
  logo: ILogo
  materialTheme: Theme
  permissions: IPermission[]
  component: LoadableComponent<ILayout> | React.FC<ILayout>
  funcao?: IUserFunction
  funcoes?: IUserFunction[]
  module?: {
    mainModule?: ENTITY_ENUM
    subModule?: TSubModules
  }
  isCompanyPrivate?: boolean
  company: ICompany
}

export interface IFunctionsEntity {
  id: string
  nome: string
  tipo: ENTITY_ENUM
  informacoes?: IInformations
}

export enum ENTITY_ENUM {
  EMPLOYEE = 'emprego',
  COMPANY = 'empresa',
  WORKER_COMPANY = 'empresaetrabalhador',
  FINANCIAL = 'financeira',
  SALES_CHANNEL = 'canalvenda',
  CLIENT_CP = 'clientecp',
  CORBAN = 'corban',
  CDC = 'canalvendacdc',
  CLIENT_CDC = 'clientecdc',
  CDCVEICULOS = 'canalvendacdcveiculo',
  CLIENT_CDV = 'clientecdcveiculo',
  PJ = 'canalvendapj',
  CLIENT_PJ = 'clientepj',
  SUPERVISOR = 'supervisor',
  CLIENT_CDV_PJ = 'clientecdcveiculopj',
  CLIENT_CT = 'clienteetrabalhador',
}

export default IEntity
